import { Base } from "./base";
import { Lessee } from '../Interfaces';

export class Agreement extends Base {
    name: string;
    date_begin: string;
    date_begin_page: number;
    date_expires: string;
    date_expires_page: number;
    amount: number;
    amount_page: number;
    lessee_page: number;
    constructor(json?: Object, public lessee?: Lessee) {
        super(json);
    }
    toString(): string {
        return this.name;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/agreement.ts